export default "__VITE_PUBLIC_ASSET__778412fe__"